import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addSubAdmin, addSubAdminPermission, blockUnblockSubAdmin, deleteSubAdmin, editSubAdmin, editSubAdminPermission, permissionModuleListing, subAdminListing, viewSubAdmin } from "../apis/apiHandler";

export const allSubAdmins = createAsyncThunk(
    'subAdmin/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subAdminListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addSubAdmins = createAsyncThunk(
    'subAdmin/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addSubAdmin(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editSubAdmins = createAsyncThunk(
    'subAdmin/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editSubAdmin(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewSubAdminDetails = createAsyncThunk(
    'subAdmin/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewSubAdmin(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteSubAdmins = createAsyncThunk(
    'subAdmin/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSubAdmin(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeSubAdminStatus = createAsyncThunk(
    'subAdmin/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockSubAdmin(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addSubAdminPermissions = createAsyncThunk(
    'subAdmin/permission-add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addSubAdminPermission(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editSubAdminPermissions = createAsyncThunk(
    'subAdmin/permission-edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editSubAdminPermission(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const permissionModuleListings = createAsyncThunk(
    'subAdmin/permissions',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await permissionModuleListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    subAdminList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    subAdminDetail: {},
    deleteSuccess: false,
    statusSuccess: false,
    addPermissionSuccess: false,
    editPermissionSuccess: false,
    permissionModuleList: []
};

const subAdminSlice = createSlice({
    name: 'subAdmin',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allSubAdmins.pending, (state) => {
                state.loading = true;
            })
            .addCase(allSubAdmins.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subAdminList = payload?.data;
            })
            .addCase(allSubAdmins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addSubAdmins.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addSubAdmins.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addSubAdmins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editSubAdmins.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editSubAdmins.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editSubAdmins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewSubAdminDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewSubAdminDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subAdminDetail = payload?.data;
            })
            .addCase(viewSubAdminDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteSubAdmins.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteSubAdmins.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteSubAdmins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeSubAdminStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeSubAdminStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeSubAdminStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
            .addCase(addSubAdminPermissions.pending, (state) => {
                state.loading = true;
                state.addPermissionSuccess = false;
                state.error = null;
            })
            .addCase(addSubAdminPermissions.fulfilled, (state) => {
                state.loading = false;
                state.addPermissionSuccess = true;
            })
            .addCase(addSubAdminPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addPermissionSuccess = false;
            })
            .addCase(editSubAdminPermissions.pending, (state) => {
                state.loading = true;
                state.editPermissionSuccess = false;
                state.error = null;
            })
            .addCase(editSubAdminPermissions.fulfilled, (state) => {
                state.loading = false;
                state.editPermissionSuccess = true;
            })
            .addCase(editSubAdminPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editPermissionSuccess = false;
            })
            .addCase(permissionModuleListings.pending, (state) => {
                state.loading = true;
            })
            .addCase(permissionModuleListings.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.permissionModuleList = payload?.data;
            })
            .addCase(permissionModuleListings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export default subAdminSlice.reducer;